module.exports = __webpack_public_path__ + "img/fernando.47737dcc.png";